module.exports = "https://cdn.hellotech.com/client-assets/camera_square_9d12921fc6a8353b803d3e43f099bb3d.jpg";